module.exports = __webpack_public_path__ + "img/color-d-2@2x.02c01a6.webp";